import { mq } from '@kvdbil/components';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import styled from 'styled-components';
import { loginFlowStep } from '~/App/shared/actions/loginFlowActions';
import Head, { Props as HeadProps } from '~/App/shared/components/Head';
import { RouteComponentProps } from '~/App/shared/interfaces/routes';
import { translateRoute } from '~/App/shared/localization';
import useCanonicalUrl from '~/App/shared/hooks/useCanonicalUrl';
import { useTranslation } from '~/Locale';
import ComponentPadding from '../../../Layout/ComponentPadding';
import Section from '../../../Layout/Section';
import { SignIn } from '../components/SignIn';

const Content = styled(ComponentPadding)`
  display: flex;
  flex-direction: column;

  ${mq('tablet')} {
    margin-top: 0;
  }
`;

export type SignInViewProps = { data?: HeadProps } & RouteComponentProps;

export const SignInView = ({ data }: SignInViewProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const canonicalUrl = useCanonicalUrl(pathname);
  const history = useHistory();

  const handleOnSignIn = useCallback(() => {
    dispatch(loginFlowStep({ navigateCallback: history.replace }));
  }, [dispatch, history]);

  const handlePressCreateAccount = useCallback(() => {
    const url = translateRoute(
      t,
      '/ROUTES.MEMBER/ROUTES.MEMBER_REGISTER_PRIVATE'
    );

    history.push(url);
  }, [history, t]);

  const handlePressForgotPassword = useCallback(
    (email?: string) => {
      if (email) sessionStorage.setItem('email', email);
      const url = translateRoute(
        t,
        '/ROUTES.MEMBER/ROUTES.MEMBER_FORGOT_PASSWORD'
      );

      history.push(url);
    },
    [history, t]
  );

  return (
    <Content>
      <Section spacing={0} backgroundColor="light" maxWidth={22.563}>
        <Head
          {...data}
          title={t('PAGE_TITLES.MEMBER_LOGIN')}
          link={[{ rel: 'canonical', href: canonicalUrl }]}
        />

        <SignIn
          onPressCreateAccount={handlePressCreateAccount}
          onPressForgotPassword={handlePressForgotPassword}
          onSignIn={handleOnSignIn}
        />
      </Section>
    </Content>
  );
};

export default SignInView;
